import { Flex, Text, VStack } from "@chakra-ui/react";
import { TrustPilot } from "@airhelp/icons";
import { useTrustpilotInfo } from "contexts/DataContext";
import { useLocalizedData } from "contexts/LocalizationContext/hooks";
import { useTranslations } from "contexts/LocalizationContext";
import { Stars } from "./Stars";

export const TrustpilotExcellent = () => {
  const { numberOfReviews: { total } = { total: 0 } } = useTrustpilotInfo();
  const { getLocalizedNumber } = useLocalizedData();
  const translations = useTranslations();

  const numberOfReviews = getLocalizedNumber(total);

  return (
    <VStack spacing={1} align="flex-start">
      <Flex align="center">
        <Text fontSize="lg" fontWeight="bold" color="primary.900" mr={4}>
          {translations("excellent")}
        </Text>
        <Stars />
      </Flex>
      <Flex align="center" justify="center">
        <Text fontSize="sm" fontWeight="bold" color="primary.900" mr={1}>
          {numberOfReviews}
        </Text>
        <Text fontSize="sm" color="primary.900">
          {translations("trustpilot_reviews_on")}
        </Text>
        <TrustPilot ml={2} w={5} h={5} />
        <Text fontSize="sm" fontWeight="bold" color="primary.900">
          Trustpilot
        </Text>
      </Flex>
    </VStack>
  );
};
